import React from 'react';

export const CustomAmericanFlagDisabled = (): JSX.Element => (
    <svg width={'19'} height={'12'} viewBox={'0 0 19 12'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'}>
        <g opacity={'0.4'}>
            <rect width={'18'} height={'12'} transform={'translate(0.694641)'} fill={'white'} />
            <path
                fillRule={'evenodd'}
                clipRule={'evenodd'}
                d={'M0.694641 0V0.923077H18.6946V0H0.694641Z'}
                fill={'#D91667'}
            />
            <path
                fillRule={'evenodd'}
                clipRule={'evenodd'}
                d={'M0.694702 1.84619V2.76927H18.6947V1.84619H0.694702Z'}
                fill={'#D91667'}
            />
            <path
                fillRule={'evenodd'}
                clipRule={'evenodd'}
                d={'M0.694702 3.69238V4.61546H18.6947V3.69238H0.694702Z'}
                fill={'#D91667'}
            />
            <path
                fillRule={'evenodd'}
                clipRule={'evenodd'}
                d={'M0.694702 5.53833V6.46141H18.6947V5.53833H0.694702Z'}
                fill={'#D91667'}
            />
            <path
                fillRule={'evenodd'}
                clipRule={'evenodd'}
                d={'M0.694702 7.38477V8.30784H18.6947V7.38477H0.694702Z'}
                fill={'#D91667'}
            />
            <path
                fillRule={'evenodd'}
                clipRule={'evenodd'}
                d={'M0.694702 9.23096V10.154H18.6947V9.23096H0.694702Z'}
                fill={'#D91667'}
            />
            <path
                fillRule={'evenodd'}
                clipRule={'evenodd'}
                d={'M0.694702 11.0769V12H18.6947V11.0769H0.694702Z'}
                fill={'#D91667'}
            />
            <rect x={'0.694641'} width={'9'} height={'6.46154'} fill={'#265CFF'} />
            <rect x={'0.694641'} width={'9'} height={'6.46154'} fill={'black'} fillOpacity={'0.4'} />
        </g>
    </svg>
);
